import { useObserver } from 'mobx-react';
import { useRef } from 'react';
import useMst from '~/src/hooks/useMst';
import useResourcePagination from '~/src/hooks/useResourcePagination';
import SortByOrder from '~/src/hooks/sortByOrder';

const useTemplateDefaultValuesPagination = () => {
  const { templateDefaultValues } = useMst((store) => ({
    templateDefaultValues: store.templateDefaultValues,
  }));

  const {
    loading,
    next,
    page,
    empty,
    setSearch,
    done,
    setSortBy,
    setOrder,
    setFilters,
  } = useResourcePagination({
    fetch: templateDefaultValues.getTemplateDefaultValuesList,
    limit: 10,
    order: SortByOrder.desc,
  });

  // Use ref to track previous data and prevent unnecessary updates
  const prevDataRef = useRef<any[]>([]);
  const prevDataLengthRef = useRef(0);

  const listData = useObserver(() => {
    const currentData = templateDefaultValues.list.flat();
    const currentLength = currentData.length;

    // Only update if the length has actually changed
    if (currentLength !== prevDataLengthRef.current) {
      prevDataLengthRef.current = currentLength;
      prevDataRef.current = currentData;
      return currentData;
    }

    return prevDataRef.current;
  });

  return {
    next,
    page,
    empty,
    data: listData,
    loading,
    done,

    setSearch,
    setSortBy,
    setOrder,
    setFilters,
  };
};

export default useTemplateDefaultValuesPagination;
